import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatureFlags } from '../../context/FeatureFlagContext';

// With phase teams on (ppPhaseEntry) the pre-processing stage is one station per
// team plus Lot Check, and the older combined screens are retired rather than
// offered beside them — a second way to key the same figure is exactly the
// confusion the stations remove. Their URLs still arrive from bookmarks,
// notifications and the assistant, so they redirect to the screen that replaced
// them. With the flag off the old screen renders unchanged.
export default function PhaseRedirect({ to, children }) {
  const { isEnabled } = useFeatureFlags();
  if (isEnabled('ppPhaseEntry')) return <Navigate to={to} replace />;
  return children;
}
